import { createStyles } from '@mantine/styles';

var useStyles = createStyles((theme, { spacing }) => ({
  root: {
    display: "flex",
    paddingLeft: theme.fn.size({ size: spacing, sizes: theme.spacing })
  }
}));

export default useStyles;
//# sourceMappingURL=AvatarGroup.styles.js.map
